<template>
  <div class="p-mask">
    <div class="p-feedback">
      <header class="p-header">
        问题反馈
        <button
          class="p-close"
          @click="$emit('close')"
        >
          ×
        </button>
      </header>
      <feedback-panel
        title="您存在哪方面的问题需要反馈？"
        class="c-title"
      >
        <div>
          <span
            class="c-badge"
            @click="onBadgeClick(item)"
            :class="selectedId === item.code?'is-active':''"
            v-for="item in feedbackList"
            :key="item.id"
          >{{ item.name }}</span>
          <div v-if="selectedFeedback && selectedFeedback.list.length">
            <p class="c-meta mb-46">
              请选择详细原因，帮助定位问题
            </p>
            <span
              class="c-badge"
              v-for="cItem in selectedFeedback.list"
              :class="selectedSubId === cItem.code?'is-active':''"
              @click="onSubBadgeClick(cItem)"
              :key="cItem.code"
            >{{ cItem.name }}</span>
          </div>
        </div>
      </feedback-panel>

      <feedback-panel title="问题描述">
        <div class="c-textarea-container  mt--22">
          <textarea
            class="c-input c-textarea"
            placeholder="请详细描述您遇到的问题，便于我们更好定位并解决"
            v-model="questionDescription"
            maxlength="200"
          />
          <p
            class="c-meta c-count"
            :class="questionDescription.length>=200?'is-red':''"
          >
            {{ questionDescription.length }}/200
          </p>
        </div>
        <c-uploader
          v-model="fileList"
          class="mt-70"
        />
      </feedback-panel>
      <feedback-panel title="联系方式">
        <input
          class="c-input mb--22"
          placeholder="请留下您的手机号码,便于我们和您联系"
          v-model="phone"
          type="tel"
          maxlength="11"
        >
      </feedback-panel>

      <footer class="p-footer">
        <debounce-button
          class="p-button"
          :disabled="!canSubmit"
          @click="onCreateClick"
        >
          提 交
        </debounce-button>
      </footer>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import { getFeedbackConfig, createFeedback } from '@/api/feedback';
import storeCreator from '@/utils/store-creator';
import { GLOBAL_PREFIX, FEEDBACK } from '@/config/storage';
import { toLine } from '@/pages/amt-web/utils';
import { toast } from '@/pages/amt-web/utils/dd';
import CUploader from './uploader.vue';
import FeedbackPanel from './feedback-panel.vue';
import DebounceButton from './debounce-button.vue';

const FROM_HOME = 1;// app_id(1是家校本 2是家长测)
// location.href
// 对应理由下，不需要传递的参数
const routeConfig = {
  // createHw: ['classId', 'hwId', 'lessonId', 'moduleId', 'tagCode', 'questionId'],
  choiceTopic: ['classId', 'hwId', 'lessonId', 'moduleId', 'tagCode', 'questionId'],
  // 查看出题范围
  knowledgeList: ['classId', 'hwId', 'moduleId', 'tagCode', 'questionId'],
  knowledgeDetail: ['classId', 'hwId', 'moduleId'],
  questionDetail: ['classId', 'hwId', 'moduleId'],
  choiceKnowledgePoints: ['classId', 'hwId', 'lessonId', 'moduleId', 'tagCode', 'questionId'],
  // 选择题目
  teacherChoice: ['classId', 'hwId', 'lessonId', 'moduleId'],
  // 查看题目详情
  selfQuestionDetail: ['classId', 'hwId', 'moduleId'],
  // 选择课时
  chooseTagCode: ['classId', 'hwId', 'lessonId', 'moduleId', 'tagCode', 'questionId'],
  // 题包详情页
  basicPack: ['classId', 'hwId', 'lessonId', 'moduleId', 'questionId'],
  artsQuestionDetail: ['classId', 'hwId', 'moduleId'],
  // 选择古诗词（选课文）
  choiceFollowReciteContent: ['classId', 'hwId', 'lessonId', 'moduleId', 'tagCode', 'questionId'],
  viewFollowMoreDetail: ['classId', 'hwId', 'moduleId', 'tagCode', 'questionId'],
  'select-poetry': ['classId', 'hwId', 'lessonId', 'moduleId', 'tagCode', 'questionId'],
  'poetry-detail': ['classId', 'hwId', 'moduleId', 'tagCode', 'questionId'],
};
export default {
  components: { FeedbackPanel, CUploader, DebounceButton },
  name: 'Feedback',
  data() {
    const store = storeCreator.create(GLOBAL_PREFIX);
    const {
      accountId,
      userId,
      corpId,
      classId,
    } = store.get(FEEDBACK, {});
    return {
      accountId,
      userId,
      corpId,
      classId,
      feedbackList: [], // 反馈列表
      questionDescription: '', // 问题描述
      phone: '', // 电话号码
      selectedId: '',
      fileList: [],
      selectedFeedback: null,
      selectedSubId: '',
    };
  },
  computed: {
    canSubmit() {
      if (this.selectedId) {
        // 如果选中配置有二级且未选择，不可提交
        if (this.selectedFeedback.list.length && !this.selectedSubId) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.getFeedbackConfig();
  },
  methods: {
    // 缓存中获取以下数据，驼峰转下划线
    //   hw_type:
    //   hw_id:
    //   subject_id:
    //   textbook_id:
    //   course_grade_id:
    //   course_id:
    //   lesson_id:
    //   topic_id:
    //   tag_code:
    //   question_id:
    getFeedbackParam() {
      const store = storeCreator.create(GLOBAL_PREFIX);
      const feedback = store.get(FEEDBACK);
      let keyValue = Object.entries({
        ...feedback,
      });
      const paths = Object.keys(routeConfig);
      // 根据不同的路由，需要过滤掉不需要传递的参数
      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          const invalidParam = routeConfig[path];
          keyValue = keyValue.filter((item) => {
            if (!invalidParam.includes(item[0])) {
              return true;
            }
            return false;
          });
        }
      });
      return keyValue.reduce((prev, cur) => ({
        ...prev,
        [toLine(cur[0])]: cur[1],
      }), {});
    },
    onCreateClick() {
      return createFeedback({
        primary_cat_id: this.selectedId,
        secondary_cat_id: this.selectedSubId,
        route: this.$route.path,
        app_id: FROM_HOME,
        desc: this.questionDescription,
        picture_urls: this.fileList.join(','),
        phone: this.phone,
        ...this.getFeedbackParam(),
      }).then((res) => {
        if (res.code === 200) {
          toast('感谢您的反馈，我们将尽快处理您反馈的问题～');
          this.$emit('close');
        } else {
          toast('提交失败，请稍后重试');
        }
      }).catch(() => {
        toast('提交失败，请稍后重试');
      });
    },
    onBadgeClick(item) {
      this.selectedId = item.code;
      this.selectedFeedback = item;
      this.selectedSubId = '';
    },
    onSubBadgeClick(item) {
      this.selectedSubId = item.code;
    },
    getFeedbackConfig() {
      if (!this.accountId) {
        console.log('未获取到用户信息');
        return;
      }
      return getFeedbackConfig({
        account_id: this.accountId,
      }).then((res) => {
        if (res.code === 200) {
          this.feedbackList = res.data.feedback_list;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.p-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 99999;
}
.p-feedback {
  width: 100%;
  height: 90vh;
  max-height: 90vh;
  overflow-y: auto;
  background: rgba(242, 244, 245, 1);
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  padding-bottom: 130px;
  border-radius: 32px 32px 0px 0px;
  .p-header {
    // padding: 30px;
    height: 90px;
    line-height: 90px;
    width: 100%;
    background: #E6EBEF;
    color: rgba(17, 31, 44, 1);
    font-size: 34px;
    text-align: center;
    position: fixed;
    border-radius: 32px 32px 0px 0px;
  }
  .c-title{
    margin-top: 90px;
  }
  .p-close {
    font-size: 50px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
  }
  .is-red {
    color: red !important;
  }
  .p-footer {
    width: 100%;
    height: 124px;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px rgba(17, 31, 44, 0.12);
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .p-button {
      width: 686px;
      height: 92px;
      border-radius: 24px;
      color: #fff;
      background: rgba(0, 137, 255, 1);
      font-size: 36px;
      &:disabled {
        background: rgba(0, 137, 255, 0.4);
        border: 1px solid rgba(17, 31, 44, 0.08);
      }
    }
  }
  .uploader-container {
    height: 200px;
    display: flex;
  }
}
</style>
